import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">

        <p className="footer-address">
          4/445 Victoria Road, Taperoo, Adelaide SA 5017
        </p>

        <div className="footer-social">

          {/* Instagram */}
          <a
            href="https://www.instagram.com/rugas.cafe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-wrap"
          >
            <svg
              viewBox="0 0 24 24"
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm0 2h10c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3zm5 3.3A4.7 4.7 0 0 0 7.3 12 4.7 4.7 0 0 0 12 16.7 4.7 4.7 0 0 0 16.7 12 4.7 4.7 0 0 0 12 7.3zm0 2A2.7 2.7 0 0 1 14.7 12 2.7 2.7 0 0 1 12 14.7 2.7 2.7 0 0 1 9.3 12 2.7 2.7 0 0 1 12 9.3zM17.8 6a1 1 0 100 2 1 1 0 000-2z"
              />
            </svg>
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/rugascafe"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-wrap"
          >
            <svg
              viewBox="0 0 24 24"
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-3h2.5V9.8c0-2.5 1.5-3.9 3.7-3.9 1 0 2 .1 2.3.1v2.6h-1.3c-1.3 0-1.7.8-1.7 1.6V12H17l-.5 3h-2.3v7A10 10 0 0 0 22 12z"
              />
            </svg>
          </a>

        </div>

        <p className="footer-copy">
          © {new Date().getFullYear()} All rights reserved Ruga's Cafe. Built by{" "}
          <a href="https://2merative.com" target="_blank" rel="noopener noreferrer">
            2merative.com
          </a>
        </p>

      </div>
    </footer>
  );
}
